/**
 * Product Thumb Image Error Handler
 *
 * Replaces broken linked-product thumbnails with a shared placeholder render.
 */

import { ProductThumbImageErrorHandlerForm } from "./product-thumb-image-error-handler-form";
import type { ProductThumbImageErrorHandlerRender } from "./product-thumb-image-error-handler-render";

interface ProductThumbImageErrorHandlerDeps {
    render: ProductThumbImageErrorHandlerRender;
}

class ProductThumbImageErrorHandler {
    public render: ProductThumbImageErrorHandlerRender;
    private readonly form: ProductThumbImageErrorHandlerForm;

    public constructor(deps: ProductThumbImageErrorHandlerDeps) {
        this.render = deps.render;
        this.form = new ProductThumbImageErrorHandlerForm();
    }

    public handleImageError(event: Event): void {
        const target = this.form.getEventTarget(event);
        if (!(target instanceof HTMLImageElement)) return;

        const thumb = this.form.getThumb(target);
        if (!(thumb instanceof HTMLElement)) return;

        this.render.replaceBrokenThumbImage(target);
    }

    public replaceAlreadyBrokenImages(root: ParentNode = document): void {
        const images = this.form.getImages(root);
        images.forEach((img) => {
            if (img.complete && img.naturalWidth === 0) {
                this.render.replaceBrokenThumbImage(img);
            }
        });
    }
}

export { ProductThumbImageErrorHandler };
